import * as yup from 'yup';

const validationSchema = yup.object().shape({
  cellphone: yup.string().required('O campo celular é obrigatório.'),
  jornada: yup.string().required('A jornada é obrigatória.'),
  hours_extra: yup.string().required('Selecione se o técnico tem horas extras.'),
});
export default validationSchema;
